// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"68f09e32","264":"6870a63a","453":"0b6f9ac2","480":"fcda72c0","638":"60ea126b","738":"35d49a0f"}[chunkId] + ".chunk.js";
};